require('./aggregatorCommercialAdd.scss')

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
const OKTag = require('components/commons/OKTag/OKTag');
import { OKButton } from 'commonsComponents/OKButton'

// @utilities
import withContactCenterValidation from 'utilities/withContactCenterValidation';
import Storage from 'utilities/storage';
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
import { SELECTED_BANK, PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';

class AggregatorCommercialAdd extends React.PureComponent {

    handleOnAddEntities() {
        Storage.localStorage.remove(SELECTED_BANK)
        Storage.localStorage.remove(PSD2_FLOW_TYPE)
        this.props.history.push('/myprofile/global/entities/add')
    }

    handleOnGlobalPosition() {
        this.props.history.push('/myprofile/global/entities/accounts')
    }

    renderLeftButton = () => {
        const { showGlobalPositionButton } = this.props

        return (
            <div className="aggregator-commercial-add__buttons__left col-xs-6">
                {showGlobalPositionButton ?
                    (
                        <OKButton
                            modifier="ghost"
                            inverse={true}
                            onClick={() => this.handleOnGlobalPosition()}
                        >
                            {formatText('aggregatorCommercialAdd-url')}
                        </OKButton>
                    ) :
                    (
                        <OKButton onClick={() => this.handleOnAddEntities()}>
                            {formatText('aggregatorCommercialAdd-button')}
                        </OKButton>
                    )
                }
            </div>
        )
    }


    renderRightButton = () => {
        const { showGlobalPositionButton } = this.props
        if (!showGlobalPositionButton)
            return null

        return (
            <div className="aggregator-commercial-add__buttons__right col-xs-6">
                <OKButton onClick={() => this.handleOnAddEntities()}>
                    {formatText('aggregatorCommercialAdd-button')}
                </OKButton>
            </div>
        )
    }

    render() {
        const tagContent = formatText('aggregatorCommercialAdd-new');

        return (
            <div className="aggregator-commercial-add">
                <div className="aggregator-commercial-add__title">
                    <div className="aggregator-commercial-add__title__text">
                        <FormattedText value="aggregatorCommercialAdd-title" />
                    </div>
                    <div className="aggregator-commercial-add__title__pill">
                        <OKTag
                            content={tagContent}
                            context="arrow"
                            type="new"
                        />
                    </div>
                </div>
                <div className="aggregator-commercial-add__text">
                    <FormattedText value="aggregatorCommercialAdd-text" />
                </div>
                <div className="row aggregator-commercial-add__buttons">
                    {this.renderLeftButton()}
                    {this.renderRightButton()}
                </div>
            </div>
        );
    }
}

AggregatorCommercialAdd.propTypes = {
    showGlobalPositionButton: PropTypes.number,
    history: PropTypes.object.isRequired,
}

const AggregatorCommercialAddCCValidated = withContactCenterValidation(withRouter(AggregatorCommercialAdd));
export default withRouter(AggregatorCommercialAdd)
export { AggregatorCommercialAddCCValidated }
